<template>
  <admin-layout>
    <div class="border-0 page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">Algoritmo</h1>
        </div>

        <div class="col-sm-auto">
          <button type="button" @click="onSubmit" class="btn btn-primary">Salva</button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12">
        <div class="card card-algorithm">
          <div class="card-header">
            <h3 class="mb-0">Algoritmo privato</h3>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>Imposta di registro</label>
              <input
                type="number"
                v-model="form.imposta"
                :class="{ 'is-invalid': form.errors.imposta }"
                class="js-masked-input form-control"
                data-hs-mask-options='{"template": "##0.00%"}'
                placeholder="%"
              />
              <span class="invalid-feedback d-block" v-if="form.errors.imposta" v-text="form.errors.imposta"></span>
            </div>

            <div class="form-group">
              <label>Provvigione agenzia</label>
              <input
                type="number"
                v-model="form.provvigione"
                :class="{ 'is-invalid': form.errors.provvigione }"
                class="js-masked-input form-control"
                data-hs-mask-options='{"template": "##0.00%"}'
                placeholder="%"
              />
              <span class="invalid-feedback d-block" v-if="form.errors.provvigione" v-text="form.errors.provvigione"></span>
            </div>

            <div class="form-group">
              <label>Costo di ristrutturazione per immobili che richiedono un intervento completo</label>
              <input
                type="number"
                v-model="form.ristrutturazione_completa"
                :class="{ 'is-invalid': form.errors.ristrutturazione_completa }"
                class="js-masked-input form-control"
                data-hs-mask-options='{"template": "##0.00"}'
                placeholder="€/mq"
              />
              <span class="invalid-feedback d-block" v-if="form.errors.ristrutturazione_completa" v-text="form.errors.ristrutturazione_completa"></span>
            </div>

            <div class="form-group">
              <label>Costo di ristrutturazione per immobili in buono stato</label>
              <input
                type="number"
                v-model="form.ristrutturazione_parziale"
                :class="{ 'is-invalid': form.errors.ristrutturazione_parziale }"
                class="js-masked-input form-control"
                data-hs-mask-options='{"template": "##0.00"}'
                placeholder="€/mq"
              />
              <span class="invalid-feedback d-block" v-if="form.errors.ristrutturazione_parziale" v-text="form.errors.ristrutturazione_parziale"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="card card-algorithm">
          <div class="card-header">
            <h3 class="mb-0">Algoritmo pubblico</h3>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label class="mb-4">Parametri di variazione</label>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-center d-inline-flex align-items-center justify-content-center" id="min-percent">-</span>
                  </div>
                  <input
                    type="number"
                    v-model="form.min"
                    :class="{ 'is-invalid': form.errors.min }"
                    id="minLabel"
                    placeholder="%"
                    class="js-masked-input form-control"
                    data-hs-mask-options='{"template": "##0.00%"}'
                    aria-describedby="min-percent"
                  />
                </div>
                <span class="invalid-feedback d-block" v-if="form.errors.min" v-text="form.errors.min"></span>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-center d-inline-flex align-items-center justify-content-center" id="max-percent">+</span>
                  </div>
                  <input type="number" v-model="form.max" :class="{ 'is-invalid': form.errors.max }" class="form-control" id="maxdLabel" placeholder="%" aria-describedby="max-percent" />
                </div>
                <span class="invalid-feedback d-block" v-if="form.errors.max" v-text="form.errors.max"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";

export default {
  components: {
    AdminLayout,
  },

  data() {
    return {
      form: this.$inertia.form(this.$page.props.settings),
    };
  },

  methods: {
    onSubmit() {
      this.form.post(route("algorithm.store"), {
        onSuccess: () => {
          this.$toast.success("L'algoritmo è stato salvato con successo");
        },
        onError: () => {},
      });
    },
  },
};
</script>
